export const socialsData = {
  github: "https://github.com/alihamzarao6",
  facebook: "https://www.facebook.com/alihamza.rao.909?mibextid=ZbWKwL",
  linkedIn: "https://www.linkedin.com/in/ali-hamza-rao-99a322245/",
  instagram: "https://www.instagram.com/alihamzarao3/",
  // codepen: "https://codepen.io/",
  // twitter: "https://twitter.com/UsamaAkbar02",
  // reddit: "https://www.reddit.com/user/",
  //   blogger: "https://www.blogger.com/",
  // medium: "https://medium.com/@",
  // stackOverflow: "https://stackoverflow.com/users/20552593/usamaakbar",
  // gitlab: "https://gitlab.com/UsamaAkbar",
  //   youtube: "https://martian code camp",
};
